var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcDisable = function SvgIcDisable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#2F3641",
    fillRule: "evenodd",
    d: "M12,4 C16.418278,4 20,7.581722 20,12 C20,16.418278 16.418278,20 12,20 C7.581722,20 4,16.418278 4,12 C4,7.581722 7.581722,4 12,4 Z M16.8906459,8.52332235 C17.589169,9.50416765 18,10.7041065 18,12 C18,15.3137085 15.3137085,18 12,18 C10.7041065,18 9.50416765,17.589169 8.52332235,16.8906459 Z M12,6 C13.2958935,6 14.4958324,6.41083098 15.4766776,7.10935412 L7.10935412,15.4766776 C6.41083098,14.4958324 6,13.2958935 6,12 C6,8.6862915 8.6862915,6 12,6 Z"
  })));
};
export default SvgIcDisable;